module.exports = __webpack_public_path__ + "static/img/mark4-DxM9vvdf.a926f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark4-DxM9vvdf.png
// module id = JGNQ
// module chunks = 16